<template>
  <v-snackbar
    v-model="snack"
    timeout="10000"
    :color="snackColor"
    :top="true"
    :rtl="true"
  >
    <span class="white--text">{{ text }}</span>
    <v-btn text @click="snack = false">{{ $t("close") }}</v-btn>
  </v-snackbar>
</template>

<script>
export default {
  data() {
    return {
      text: "",
      snack: false,
      snackColor: "green"
    };
  },
  methods: {
    sendSuccessAlert(text) {
      this.snack = true;
      this.text = text;
      this.snackColor = "green";
    },
    sendErrorAlert(text) {
      this.text = text;
      this.snackColor = "red";
      this.snack = true;
    }
  }
};
</script>

<style></style>
